/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationCount } from '../models/AccommodationCount';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationCountService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Returns number of accommodations for given filters
     * Counts accommodations using the same filters as listing endpoint.
     * @param adults
     * @param amenity
     * @param amenityGroup
     * @param bookableOnline
     * @param bookingOptions
     * @param category
     * @param children
     * @param childrenAge
     * @param dateFrom
     * @param dateTo
     * @param provision
     * @param rating
     * @param region
     * @param voivodeship
     * @param latitude
     * @param longitude
     * @param country Country ID from NOP
     * @param radius Radius to search within coordinates in meters
     * @param order Order by distance from provided coordinates
     * @param city
     * @param nocCountry Country ID from Noc
     * @param flexibleDays
     * @param cms
     * @param cmsFieldPath
     * @param cmsDocumentId
     * @param poi POI ID to search accommodations around
     * @param priceFrom
     * @param priceTo
     * @param beachDistance Filter accommodations by maximum distance from the beach (in meters).
     * @param tags One or more accommodation tags (comma-separated).
     * @returns AccommodationCount AccommodationCount resource
     * @throws ApiError
     */
    public countAccommodationForListing(
        adults?: number,
        amenity?: Array<string>,
        amenityGroup?: Array<string>,
        bookableOnline?: 0 | 1,
        bookingOptions?: Array<string>,
        category?: Array<string>,
        children?: number,
        childrenAge?: Array<number>,
        dateFrom?: string,
        dateTo?: string,
        provision?: Array<string>,
        rating?: number,
        region?: number,
        voivodeship?: number,
        latitude?: number,
        longitude?: number,
        country?: number,
        radius?: number,
        order?: Array<string>,
        city?: number,
        nocCountry?: number,
        flexibleDays?: number,
        cms?: string,
        cmsFieldPath?: string,
        cmsDocumentId?: string,
        poi?: string,
        priceFrom?: number,
        priceTo?: number,
        beachDistance?: number,
        tags?: Array<'kitchen' | 'private-bathroom'>,
    ): CancelablePromise<AccommodationCount> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/count',
            query: {
                adults: adults,
                amenity: amenity,
                'amenity-group': amenityGroup,
                'bookable-online': bookableOnline,
                'booking-options': bookingOptions,
                category: category,
                children: children,
                'children-age': childrenAge,
                'date-from': dateFrom,
                'date-to': dateTo,
                provision: provision,
                rating: rating,
                region: region,
                voivodeship: voivodeship,
                latitude: latitude,
                longitude: longitude,
                country: country,
                radius: radius,
                order: order,
                city: city,
                'noc-country': nocCountry,
                'flexible-days': flexibleDays,
                cms: cms,
                'cms-field-path': cmsFieldPath,
                'cms-document-id': cmsDocumentId,
                poi: poi,
                'price-from': priceFrom,
                'price-to': priceTo,
                beach_distance: beachDistance,
                tags: tags,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
